import { unregisterDeviceToken } from '../push';
import { useNavigate } from 'react-router-dom';
import { supabase } from '../supabase';
import { showConfirm } from '../dialog';

// Small, low-emphasis "Sign out" link for the onboarding/account-setup screens,
// so someone mid-signup can back out. Confirms first to avoid accidental taps.
export default function SignOutLink({ style }) {
  const navigate = useNavigate();

  const handleSignOut = async () => {
    if (!(await showConfirm('Sign out and leave setup?', { confirmLabel: 'Sign out' }))) return;
    // scope:'local' clears the session on-device WITHOUT the server revocation
    // round-trip, which can hang or throw right after a native social sign-in and
    // strand the user on this screen. try/catch so we always land back at login.
    try {
      await unregisterDeviceToken();
      await supabase.auth.signOut({ scope: 'local' });
    } catch (e) {
      console.error('Sign out error (continuing anyway):', e);
    }
    navigate('/');
  };

  return (
    <button type="button" style={{ ...styles.btn, ...style }} onClick={handleSignOut}>
      Sign out
    </button>
  );
}

const styles = {
  btn: {
    marginTop: '10px', padding: '8px', width: '100%',
    background: 'none', border: 'none', cursor: 'pointer',
    color: 'var(--text-muted)', fontSize: '13px', fontWeight: '500',
    fontFamily: 'inherit',
  },
};
